// extracted by mini-css-extract-plugin
export var container = "_2c-0";
export var disabled = "_2c-4";
export var fullWidth = "_2c-3";
export var lined = "_2c-1";
export var selected = "_2c-5";
export var tab = "_2c-2";